var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle64BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M6 41v14l7.251.725A2.5 2.5 0 0 0 16 53.237V28.762a2.5 2.5 0 0 0-2.749-2.487L6 27v14Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6 56V26"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M53 34V24l-8.274-.752A2.5 2.5 0 0 0 42 25.738v6.524a2.5 2.5 0 0 0 2.726 2.49L53 34Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m51 35 .445-.223A2.813 2.813 0 0 0 53 32.261v-6.523c0-1.065-.602-2.04-1.555-2.516L51 23"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M53 54V44l-8.274-.752A2.5 2.5 0 0 0 42 45.738v6.524a2.5 2.5 0 0 0 2.726 2.49L53 54Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m51 55 .445-.223A2.813 2.813 0 0 0 53 52.261v-6.523c0-1.065-.602-2.04-1.555-2.516L51 43"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M21.5 22.002a1.5 1.5 0 0 0-1.5 1.5v31a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-31a1.5 1.5 0 0 0-1.5-1.5h-15Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M8.5 8H43l.725 7.251A2.5 2.5 0 0 1 41.237 18H18.5a2.5 2.5 0 0 0-2.5 2.5v20.639a2.5 2.5 0 0 1-2.835 2.477L6 42.647V10.5A2.5 2.5 0 0 1 8.5 8Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6 42.636V10.5A2.5 2.5 0 0 1 8.5 8H44"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M24 71h10l.752-8.274A2.5 2.5 0 0 0 32.262 60h-6.524a2.5 2.5 0 0 0-2.49 2.726L24 71Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m23 69 .223.445A2.813 2.813 0 0 0 25.738 71h6.524c1.065 0 2.039-.602 2.515-1.555L35 69"
})));
SvgRectangle64BError.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle64BError);
export default ForwardRef;